import React from "react";
import OrgLogo from "../../Components/Other/logo";
import { ReactComponent as Logo } from "../../Assets/Auth/ForgotPassword/Reset.svg";
import Title from "../../Components/Authentication/authTitle";
import { useNavigate } from "react-router-dom";

const SuccessPass = () => {
  const navigate = useNavigate();

  return (
    <div className="login-container flex-container flex-center">
      <OrgLogo />
      <div className="mid-container mirror-container">
        <div className="login-form flex-container flex-center flex-column">
          <div className="login-icon-container">
            <Logo className="login-icon" />
          </div>
          <Title
            title="Password Reset!"
            tagline1="Your password has been successfully reset. Click below to"
            tagline2="continue your access."
          />
          <div className="login-button width-100">
            <button
              onClick={() => {
                navigate("/");
              }}
              className="width-100 alt-black font-white font-SemiBold border-15"
            >
              Return to sign-in screen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPass;
